import { getRootStore } from "../store/init";

export const AUDIENCES = ["platform", "publisher", "author"] as const;
export type Audience = typeof AUDIENCES[number];

// Los hosts de cada audiencia (hkconfig.json, sección audiences). Un host es de
// una sola audiencia; el que atiende dos durante una transición lo declara el
// server (AUDIENCE_ORIGINS), no el cliente.
export const AUDIENCE_HOSTS: Readonly<Record<Audience, string[]>> = {
  platform: ["admin.jupiter.ar", "localhost:3001"],
  publisher: ["app.jupiter.ar", "localhost:3000"],
  author: ["autores.jupiter.ar", "localhost:3002"],
};

const AUDIENCE_TITLES: Readonly<Record<Audience, string>> = {
  platform: "Jupiter · Administración",
  publisher: "Jupiter",
  author: "Jupiter · Autores",
};

const isAudience = (value: unknown): value is Audience =>
  typeof value === "string" &&
  (AUDIENCES as ReadonlyArray<string>).includes(value);

let warnedAboutEnv = false;

/**
 * La audiencia del host, la que vale antes del login. REACT_APP_AUDIENCE
 * válida manda; mal escrita, se avisa y se sigue por el host. Un host que no
 * figura en ninguna audiencia es "publisher".
 */
export function hostAudience(): Audience {
  const fromEnv = process.env.REACT_APP_AUDIENCE;
  if (fromEnv) {
    if (isAudience(fromEnv)) {
      return fromEnv;
    }
    if (!warnedAboutEnv) {
      warnedAboutEnv = true;
      console.warn(
        `REACT_APP_AUDIENCE="${fromEnv}" no es una audiencia (${AUDIENCES.join(
          ", "
        )}): se ignora y se sigue por el host.`
      );
    }
  }
  const host = window.location.host.toLowerCase();
  for (const audience of AUDIENCES) {
    if (AUDIENCE_HOSTS[audience].includes(host)) {
      return audience;
    }
  }
  return "publisher";
}

/**
 * La audiencia de la sesión: la del rol del usuario cuando hay sesión (la
 * decide el server), la del host si no.
 */
export function currentAudience(): Audience {
  const fromRole = getRootStore().authStore.me?.role?.audience;
  return isAudience(fromRole) ? fromRole : hostAudience();
}

/** El título de una audiencia (hkconfig.json, audiences.<a>.title). */
export function titleFor(audience: Audience): string {
  return AUDIENCE_TITLES[audience];
}
